<app-hero-section></app-hero-section>
<app-services-section></app-services-section>
<app-ats-resume-section></app-ats-resume-section>
 <app-job-seekers-section></app-job-seekers-section>
 <app-career></app-career>
<!-- <app-optimize-linkedin-section></app-optimize-linkedin-section>
<app-automate-section></app-automate-section>
<app-get-ready-section></app-get-ready-section>  -->
